import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NavigationContext = createContext();

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState(location.pathname.replace('/', ''));

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     localStorage.setItem('lastVisitedPage', activePage);
  //   };
  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, [activePage]);


  useEffect(() => {
    // const currentPathParts = location.pathname.split('/').filter(part => part !== '');
    // const currentPath = currentPathParts.length > 0 ? currentPathParts[0] : '';
    // if (activePage && activePage !== currentPath) {
    //   navigate(`${activePage}`);
    // }
    if (activePage) {
      navigate(`${activePage}`);
    }
    // const handleBeforeUnload = () => {
    //   localStorage.setItem('lastVisitedPage', activePage);
    // };
    // window.addEventListener('beforeunload', handleBeforeUnload);
    // return () => {
    //   window.removeEventListener('beforeunload', handleBeforeUnload);
    // };
  }, [activePage]);

  const navigateTo = (page) => {
    setActivePage(page);
  };

  const value = {
    activePage,
    navigateTo,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};
